import React from "react";
import { Link } from "react-router-dom";
import usePageMeta from "@/lib/usePageMeta";
import { Button } from "@/components/ui/button";
import {
  Wrench, Drop, Lightning, PaintRoller, Hammer, Broom, Plant, Sparkle,
  Television, House, CheckCircle, ArrowRight
} from "@phosphor-icons/react";

const services = [
  { icon: Wrench, name: "General Handyman Repairs", items: ["TV mounting & shelving", "Door & lock repairs", "Furniture assembly", "Picture hanging"] },
  { icon: Drop, name: "Plumbing Repairs", items: ["Leaking taps & toilets", "Blocked drains", "Hot water troubleshooting", "Tap & mixer install"] },
  { icon: Lightning, name: "Electrical Repairs", items: ["Power point & switch swaps", "Light fitting install", "Ceiling fan install", "Smoke alarms"] },
  { icon: PaintRoller, name: "Painting (Interior & Exterior)", items: ["Room repaints", "Trim & cornice", "Fences & decks", "Touch-ups"] },
  { icon: Hammer, name: "Drywall & Plastering", items: ["Hole repairs", "Crack patching", "Skim coats", "Plaster cornice"] },
  { icon: Hammer, name: "Carpentry", items: ["Skirting & architraves", "Decking repairs", "Door hanging", "Custom shelving"] },
  { icon: Broom, name: "Pressure Washing", items: ["Driveways & paths", "Decks & fences", "Garage floors", "House washing"] },
  { icon: House, name: "Gutter Cleaning", items: ["Full clear-out", "Downpipe flush", "Leaf guard checks", "Annual maintenance"] },
  { icon: Sparkle, name: "Window Cleaning", items: ["Inside & out", "Frames & sills", "Fly-screen wash", "High-reach windows"] },
  { icon: Plant, name: "Lawn & Garden Maintenance", items: ["Mowing & edging", "Hedging", "Mulching & weeding", "Garden tidy-ups"] },
  { icon: Sparkle, name: "End-of-Lease Cleaning", items: ["Bond-back guarantee", "Full deep clean", "Carpet steam (add-on)", "Wall & oven cleaning"] },
  { icon: Wrench, name: "Regular Property Maintenance", items: ["Quarterly inspections", "Preventive repairs", "Property manager packages", "Investment-property care"] },
  { icon: Television, name: "TV/AV & Whitegoods Installation", items: ["Wall-mounted TVs", "Soundbar setup", "Cable management", "Washer/dryer/dishwasher install"] },
];

export default function Services() {
  usePageMeta({ title: "Services", path: "/services", description: "Plumbing, electrical, painting, drywall, carpentry, pressure washing, gutter cleaning, lawn care, end-of-lease cleaning and more across Albury/Wodonga." });
  return (
    <div data-testid="services-page">
      <section data-nav-theme="dark" className="bg-navy-deep text-white py-20 min-h-[60vh] flex items-center">
        <div className="max-w-7xl mx-auto px-5 md:px-8 w-full">
          <div className="eyebrow">Our services</div>
          <h1 className="font-display display-lg tracking-wide mt-3 leading-tight max-w-3xl">Everything you'd ever need from a handyman — and a few things you didn't know to ask for.</h1>
        </div>
      </section>
      <section data-nav-theme="light" className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={s.name} data-testid={`service-${i}`} className="bg-white border border-slate-200 p-6 rounded-sm hover:border-navy transition-colors">
                <div className="w-11 h-11 bg-navy-deep text-white flex items-center justify-center rounded-sm mb-4"><Icon size={22} weight="duotone"/></div>
                <h3 className="font-display font-bold text-navy text-lg">{s.name}</h3>
                <ul className="mt-3 space-y-1.5">
                  {s.items.map((it) => (
                    <li key={it} className="flex items-start gap-2 text-sm text-slate-700"><CheckCircle size={14} weight="fill" className="text-navy/70 mt-0.5 shrink-0"/>{it}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
        <div className="mt-14 bg-navy text-white p-10 rounded-sm text-center">
          <h3 className="font-display text-3xl ">Don't see what you need?</h3>
          <p className="mt-2 text-slate-300">If it's a job around the house, chances are we do it. Just ask.</p>
          <Link to="/contact"><Button className="pill-navy mt-5">Ask us anything <ArrowRight size={16} className="ml-2"/></Button></Link>
        </div>
      </section>
    </div>
  );
}
